<template>
  <IonItem class="stacked-input-item" :color="gray ? 'whitesmoke' : 'white'" lines="full" :id="`stackedInput-${title}`">
    <ValidationIcon :valid-icon="icon" :state="state" :errors="errors"></ValidationIcon>
    <div class="h-[60px] w-full flex flex-col justify-center">
      <div v-if="vModel" class="text-sm leading-tight text-gray-500 font-medium">{{ title }}</div>
      <input
        :type="type"
        :value="vModel"
        @input="onInput"
        class="appearance-none bg-transparent outline-none placeholder:text-gray-500 placeholder:font-medium text-gray-700 font-medium"
        :placeholder="title"
      />
    </div>
    <IconButton
      slot="end"
      size="small"
      v-if="clearable && vModel"
      icon="icon-x"
      @click="onClearClicked($event)"
      color="medium"
    ></IconButton>
  </IonItem>
</template>

<script setup lang="ts">
import { IonItem } from '@ionic/vue';
import IconButton from '../IconButton.vue';
import { FormControlError, FormControlState } from '@/composables/use-form-control';
import ValidationIcon from '../ValidationIcon.vue';

withDefaults(
  defineProps<{
    title: string;
    gray?: boolean;
    clearable?: boolean;
    icon?: string;
    type?: string;
    state?: FormControlState;
    errors?: FormControlError[];
  }>(),
  {
    clearable: true,
    type: 'text',
  }
);

const vModel = defineModel({ type: String });

function onInput(ev: any) {
  vModel.value = ev.target.value;
}

function onClearClicked(ev: MouseEvent) {
  ev.stopPropagation();
  ev.preventDefault();
  vModel.value = undefined;
}
</script>

<style scoped>
ion-item.stacked-input-item::part(native) {
  --border-width: 1px;
}

ion-item.stacked-input-item {
  --padding-start: 0px;
}
</style>
